import * as v from 'valibot';

export const deployableEnvSchema = v.fallback(
  v.pipe(v.picklist(['stage', 'prod', 'dev'], 'deployableEnv must be one of: stage, prod, dev')),
  'dev',
);
